import { Link } from 'react-router-dom';
import { MaskedLines, FadeUp } from '../components/anim';
import { CHAPTERS, UI } from '../data/portfolio';
import { useLang } from '../i18n';

export default function WorkIndex() {
  const { t } = useLang();
  return (
    <main data-testid="work-index-page" className="px-6 pt-28 md:px-10 md:pt-40">
      <div className="mx-auto max-w-[1600px]">
        <MaskedLines
          lines={[
            <h1 key="w" data-testid="work-heading" className="text-[clamp(34px,4.2vw,60px)] font-light uppercase tracking-[0.14em] text-balance">
              {t(UI.workTitle)}
            </h1>,
          ]}
        />
        <div className="mt-10 h-px bg-ink/25" />

        <div className="mt-16 pb-24 md:pb-40">
          {CHAPTERS.map((c, i) => (
            <article key={c.slug} className="grid items-center gap-8 border-t border-ink/15 py-16 md:grid-cols-12 md:gap-12 md:py-24">
              <FadeUp className={`md:col-span-6 ${i % 2 === 1 ? 'md:order-2 md:col-start-7' : ''}`}>
                <Link to={`/work/${c.slug}`} data-testid={`work-card-${c.slug}`} className="group block">
                  <div className="aspect-square overflow-hidden bg-paper">
                    <img
                      src={c.cover}
                      alt={c.title}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.02]"
                    />
                  </div>
                </Link>
              </FadeUp>
              <div className={`md:col-span-6 ${i % 2 === 1 ? 'md:order-1 md:col-start-1' : 'md:col-start-7 md:text-right'}`}>
                <FadeUp>
                  <Link to={`/work/${c.slug}`} data-testid={`work-title-${c.slug}`}>
                    <h2 className="text-[clamp(24px,3.3vw,48px)] font-light uppercase tracking-[0.1em] text-balance">
                      {c.title}
                    </h2>
                  </Link>
                </FadeUp>
              </div>
            </article>
          ))}
          <div className="border-t border-ink/15" />
        </div>
      </div>
    </main>
  );
}
